<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Crear Corte de Ahorro
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="savings_cut_details"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'savings_cuts' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import configsService from '@/services/configs'
import savingsCutService from '@/services/savings_cuts'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      savings_cut_details: {
        cut_day: {
          name: 'Día de corte',
          hint: 'Día de corte',
          value: null,
          type: 'select',
          options: [],
          validate: 'required'
        },
        month: {
          name: 'Mes',
          hint: 'Mes',
          value: null,
          type: 'select',
          options: [],
          validate: 'required'
        },
        year: {
          name: 'Año',
          hint: 'Año',
          value: '',
          type: 'text',
          min: 2018,
          max: 2200,
          validate: 'required'
        },
        end_period: {
          name: '¿Fin de periodo?',
          hint: '¿Fin de periodo?',
          value: { value: false, text: 'No' },
          type: 'select',
          options: [
            { value: false, text: 'No' },
            { value: true, text: 'Sí' }
          ],
          validate: 'required'
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    const id = 8
    configsService.getById(id).then(res => {
      let options = [
        { value: 1, text: 'Enero' },
        { value: 2, text: 'Febrero' },
        { value: 3, text: 'Marzo' },
        { value: 4, text: 'Abril' },
        { value: 5, text: 'Mayo' },
        { value: 6, text: 'Junio' },
        { value: 7, text: 'Julio' },
        { value: 8, text: 'Agosto' },
        { value: 9, text: 'Septiembre' },
        { value: 10, text: 'Octubre' },
        { value: 11, text: 'Noviembre' },
        { value: 12, text: 'Diciembre' }
      ]
      let fecha = res.data.value.split('-')

      this.savings_cut_details.cut_day.value = { value: fecha[2], text: `${fecha[2]}` }
      let index = parseInt(fecha[1]) - 1
      this.savings_cut_details.month.value = options[index]
      this.savings_cut_details.year.value = fecha[0]
    })
    this.loaded = true
  },
  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.savings_cut_details)
          let service = savingsCutService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'savings_cuts', props: { savings_cuts: res } })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },

  watch: {}
}
</script>

<style lang="scss" scoped>
.font-info {
  font-size: 1.5rem;
  color: var(--primary);
}
</style>



// WEBPACK FOOTER //
// src/components/savings_cuts/SavingsCutCreate.vue